import ActaDisplay from './ActaDisplay-ExtraBold.woff'
import ActaDisplay2 from './ActaDisplay-ExtraBold.woff2'

import CenturyExpanded from './CenturyExpanded-Roman.woff'
import CenturyExpanded2 from './CenturyExpanded-Roman.woff2'

import CenturyExpandedItalic from './CenturyExpanded-Italic.woff'
import CenturyExpandedItalic2 from './CenturyExpanded-Italic.woff2'

import CenturyExpandedBold from './CenturyExpanded-Bold.woff'
import CenturyExpandedBold2 from './CenturyExpanded-Bold.woff2'

import Futura from './Futura-Medium.woff'
import Futura2 from './Futura-Medium.woff2'

import FuturaBold from './Futura-Bold.woff'
import FuturaBold2 from './Futura-Bold.woff2'

import FuturaCondensed from './Futura-BoldCondensed.woff'
import FuturaCondensed2 from './Futura-BoldCondensed.woff2'

import Grotesque from './GrotesqueNo9-Regular.woff'
import Grotesque2 from './GrotesqueNo9-Regular.woff2'

import Akkordeon5 from './Akkordeon-Five.woff'
import Akkordeon52 from './Akkordeon-Five.woff2'

import InterRegular from './Inter-Regular.woff'
import InterRegular2 from './Inter-Regular.woff2'

import InterBold from './Inter-Bold.woff'
import InterBold2 from './Inter-Bold.woff2'

import InterExtraBold from './Inter-ExtraBold.woff'
import InterExtraBold2 from './Inter-ExtraBold.woff2'

export {
  ActaDisplay,
  ActaDisplay2,
  CenturyExpanded,
  CenturyExpanded2,
  CenturyExpandedItalic,
  CenturyExpandedItalic2,
  CenturyExpandedBold,
  CenturyExpandedBold2,
  Futura,
  Futura2,
  FuturaBold,
  FuturaBold2,
  FuturaCondensed,
  FuturaCondensed2,
  Grotesque,
  Grotesque2,
  Akkordeon5,
  Akkordeon52,
  InterRegular,
  InterRegular2,
  InterBold,
  InterBold2,
  InterExtraBold,
  InterExtraBold2,
}
